import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webLog_nginx",
  "use": "webLog_nginx-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"webLog_nginx\"><path d=\"m11.06 1.94-.44-.44H3.5v15h11V5.38zm-.31 1.81 1.5 1.5h-1.5zM13 15H5V3h4.25v3.75H13zM6.97 7.93c-.29.11-.47.39-.47.7v3.75c0 .41.34.75.75.75s.75-.34.75-.75v-1.85l2.2 2.36c.14.16.34.24.55.24.09 0 .19-.02.28-.05.29-.11.47-.39.47-.7V8.62c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.85L7.8 8.11a.75.75 0 0 0-.83-.18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol